import React from 'react'
import { useSnapshot } from 'valtio'
import { state } from '../../context/store'
import { AnimatePresence } from 'framer-motion'
import { Overlay, Bubble } from '../Blocks';
import { ModalExitApp, ModalResetCustomisation, ModalEmptyCart, ModalCameraOptions, ModalInstructions, ModalMultiRib, ModalNumber, ModalOrderSummary, ModalOrderConfirmed, ModalDisclaimer, ModalSelectModel, ModalSuperBadge } from './Modals';
import { animations } from '../animations'
import { closePopups } from '../../utilities';

const ModalContainer = () => {

    const snap = useSnapshot(state.current.modal)

    const InnerComp = () => {

        return (
            <>
                {snap.exitApp && (

                    <Bubble id="exit-bubble" key="exit-bubble" motion={animations.slideDown("spring", .8, 0.5)}>
                        <ModalExitApp id="inner-exit" />
                    </Bubble>
                )}
                {snap.selectModel && (

                    <Bubble id="select-model-bubble" key="select-model-bubble" motion={animations.slideDown("spring", .8, 0.5)}>
                        <ModalSelectModel id="inner-select-model" />
                    </Bubble>
                )}
                {snap.disclaimer && (

                    <Bubble id="disclaimer-bubble" key="disclaimer-bubble" motion={animations.slideDown("spring", .8, 0.5)}>
                        <ModalDisclaimer id="inner-exit" />
                    </Bubble>
                )}

                {snap.cameraControls && (

                    <Bubble id="camera-bubble" key="camera-bubble" motion={animations.slideDown("spring", .8, 0.5)}>
                        <ModalCameraOptions id="inner-camera" />
                    </Bubble>
                )}
                {snap.resetCustomisation && (

                    <Bubble id="reset-bubble" key="reset-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalResetCustomisation id="inner-reset" />
                    </Bubble>
                )}
                {snap.instructions && (
                    <Bubble id="instruction-bubble" key="instruction-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalInstructions width="fit-content" id="inner-instructions" />
                    </Bubble>
                )}
                {snap.multiRib && (
                    <Bubble maxW="var(--max-panel-width)" id="ribs-bubble" key="rib-bubble" bottom="true" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalMultiRib id="inner-ribs" />
                    </Bubble>
                )}
                {snap.settingNumber && (
                    <Bubble id="number-bubble" key="modal-bubble" bottom="true" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalNumber id="inner-numbers" />
                    </Bubble>
                )}
                {snap.orderSummary && (
                    <Bubble id="order-summary-bubble" key="order-summary-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalOrderSummary id="inner-order" />
                    </Bubble>
                )}
                {snap.orderConfirmed && (
                    <Bubble id="order-confirmed-bubble" key="order-confirmed-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalOrderConfirmed id="inner-confirmed" />
                    </Bubble>
                )}
                {snap.emptyCart && (
                    <Bubble id="empty-cart-bubble" key="empty-cart-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalEmptyCart id="inner-empty" />
                    </Bubble>
                )}
                {snap.superBadge && (
                    <Bubble maxW="500px" id="super-badge-bubble" key="super-badge-bubble" motion={animations.slideUp("spring", .8, 0.5)}>
                        <ModalSuperBadge id="inner-super-badge" />
                    </Bubble>
                )}
            </>
        )
    }





    if (snap.open) {
        return (
            <AnimatePresence >
                <Overlay id="modal" key="modal" motion={animations.fadeIn("spring", .2, 0)} bottomAlign={snap.bottomAlign} clearBackground={snap.clearBackground}>
                    <InnerComp />
                </Overlay>
            </AnimatePresence>

        )
    }


}

export default ModalContainer
